<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="'organiser.modules.modal.title'"
            (onClose)="onDismissClick()"
            (onSave)="onConfirmClick()">
        <form [formGroup]="inputForm">
                <div class="pb-4">
                    <span class="pb-2">{{t("organiser.modules.modal.info")}} <strong>{{organiser.fullName}}</strong></span>
                    <app-multiselect-dropdown [options]="modulesOptions" [formControlName]="'modules'"
                                              [maxItemsDisplay]="4" [isDropdownListFullWidth]="true"
                                              [dropdownLabel]="t('organiser.modules.active')"/>
                </div>
        </form>
    </app-admin-modal-layout>
</ng-container>
